import { render, staticRenderFns } from "./WxAuthorize.vue?vue&type=template&id=462ccdba&scoped=true"
import script from "./WxAuthorize.vue?vue&type=script&lang=js"
export * from "./WxAuthorize.vue?vue&type=script&lang=js"
import style0 from "./WxAuthorize.vue?vue&type=style&index=0&id=462ccdba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462ccdba",
  null
  
)

export default component.exports